import axios, { AxiosRequestConfig } from 'axios'
import convertToSnakeCase from '@Utils/ConvertToSnakeCase'

import {
  ISubmitProjectVersionUpdatePayload,
  IFetchProjectVersionSettingsPayload,
  IUpdateDownloadingElementsPayload,
  IFetchTranslationLanguagesPayload,
} from './types'

const config: AxiosRequestConfig = {
  responseType: 'json'
}

export function submitProjectVersionUpdate(payload: ISubmitProjectVersionUpdatePayload) {
  return axios.put(`/api/v1/project_versions/setup`, convertToSnakeCase(payload, ['translation_settings']), config)
}

export function fetchProjectVersionSettings(payload: IFetchProjectVersionSettingsPayload) {
  return axios.get('/api/v1/project_versions/show_settings', { params: convertToSnakeCase(payload) })
}

export function updateDownloadingElements(payload: IUpdateDownloadingElementsPayload) {
  return axios.post('/api/v1/elements/updates', convertToSnakeCase(payload), config)
}

export function fetchTranslationLanguages(payload: IFetchTranslationLanguagesPayload) {
  return axios.get('/api/v1/project_versions/show_translation_languages_language_wire', { params: convertToSnakeCase(payload) })
}
